<h2>Respiratory Pattern</h2>
<assessment-row title="Regular Rhythm">
  <p>{{ isRegularRhythm }}</p>
</assessment-row>
<assessment-row title="Quality">
  <p>{{ data.quality }}</p>
</assessment-row>

<h2>Lung Sounds</h2>
<assessment-row title="RUL">
  <p>{{ data.lungSoundsRul }}</p>
</assessment-row>
<assessment-row title="RLL">
  <p>{{ data.lungSoundsRll }}</p>
</assessment-row>
<assessment-row title="RML">
  <p>{{ data.lungSoundsRml }}</p>
</assessment-row>
<assessment-row title="LUL">
  <p>{{ data.lungSoundsLul }}</p>
</assessment-row>
<assessment-row title="LLL">
  <p>{{ data.lungSoundsLll }}</p>
</assessment-row>

<h2>Breathing</h2>
<assessment-row title="Increased work of Breathing">
  <p>{{ data.increasedWorkOfBreathing }}</p>
</assessment-row>

<h2>Cough</h2>
<assessment-row title="Cough Present">
  <p>{{ isCoughPresent }}</p>
</assessment-row>

@if (data.cough) {
<assessment-row title="Description of Cough">
  <p>{{ data.coughDescription }}</p>
</assessment-row>

<assessment-row *ngIf="isProductiveCough" title="Productive Description">
  <emr-list [list]="data.productiveDescription" emptyText="N/A"></emr-list>
</assessment-row>
}

<h2>Trach</h2>
<assessment-row title="Is Trach Present?">
  <p>{{ isTrachPresent }}</p>
</assessment-row>

@if (data.trachPresent) {
<assessment-row title="How Many Hours Since Inner Cannula Changed">
  <p>{{ data.innerCannulaChangedDay}}</p>
</assessment-row>
<assessment-row title="Trach Ties Changed">
  <p>{{ data.trachTiesChanged }}</p>
</assessment-row>
<assessment-row title="Suction Completed">
  <p>{{ data.suction }}</p>
</assessment-row>
}